/** @jsxImportSource @emotion/react */

import { lazy } from "react";
const HomeV2 = lazy(() => import("views/HomeV2"));

const Home = () => {
  return <HomeV2 />;
};

export default Home;
